import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { appAxios } from '@/network/base/appAxios';
import { toast } from 'sonner';

const AcknowledgementStep = ({ onSubmit, onBack, context, permitChatId }) => {
  const acknowledgements = context?.ackData?.acknowledgements || [];
  const [checked, setChecked] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const checkedCount = acknowledgements.filter((_, i) => checked[i]).length;
  const allChecked = acknowledgements.length > 0 && checkedCount === acknowledgements.length;

  const handleCheckAll = () => {
    const next = !allChecked;
    setChecked(Object.fromEntries(acknowledgements.map((_, i) => [i, next])));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await appAxios.post(`/Permit/v1.0/change-acknowledgement-status/${permitChatId}`, {
        modify_type: 'acknowledgement_done',
      });
      onSubmit();
    } catch {
      toast.error('Failed to submit acknowledgements. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-4 w-full">
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-400">
          {checkedCount}/{acknowledgements.length} acknowledged
        </span>
        <button onClick={handleCheckAll} className="text-xs text-blue-400 hover:text-blue-300 underline transition">
          {allChecked ? 'Uncheck All' : 'Check All'}
        </button>
      </div>
      <div className="max-h-[260px] overflow-y-auto space-y-3 pr-1 no-scrollbar">
        {acknowledgements.length === 0 ? (
          <p className="text-center text-sm text-gray-500 py-4">No acknowledgements required.</p>
        ) : (
          acknowledgements.map((item, i) => (
            <label key={i} className="flex items-start gap-3 text-sm text-gray-300 cursor-pointer">
              <input
                type="checkbox"
                checked={checked[i] || false}
                onChange={() => setChecked(prev => ({ ...prev, [i]: !prev[i] }))}
                className="mt-0.5 w-4 h-4 shrink-0"
              />
              <span>{item}</span>
            </label>
          ))
        )}
      </div>
      <button
        onClick={handleSubmit}
        disabled={!allChecked || isSubmitting}
        className="w-full bg-[#7B7B7B] hover:bg-gray-500 text-white py-3 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed text-sm flex items-center justify-center gap-2"
      >
        {isSubmitting && <Loader2 className="w-4 h-4 animate-spin" />}
        {isSubmitting ? 'Submitting…' : 'Continue'}
      </button>
      {/* <button onClick={onBack} className="w-full border border-gray-700 hover:border-gray-500 text-white py-3 rounded-lg transition text-sm">Back</button> */}
    </div>
  );
};

export default AcknowledgementStep;
